import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@clarix/auth-store';

/**
 * Gate for routes that require a valid token in the auth store.
 * If no token: redirect to /login with `?next=<current-path>` so login can route back.
 */
export function RequireAuth() {
  const token = useAuthStore((s) => s.token);
  const location = useLocation();

  if (!token) {
    // A user with a pending admin force-reset has no token but must stay on the
    // reset flow — keep them on /password-reset-required rather than sending them
    // to /login (a normal login can't complete until they reset anyway). The flag
    // is set when they land on the reset page and cleared once they log in / finish
    // resetting, so a normal signed-out user still goes to /login as before.
    if (sessionStorage.getItem('clarix.pwreset.required') === '1') {
      return <Navigate to="/password-reset-required" replace />;
    }
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return <Outlet />;
}
